
// Constantes para metas
export const METAS_TABLE = 'metas_categorias';

export const PERIODO_OPTIONS = [
  { value: 'mensal', label: 'Mensal' },
  { value: 'trimestral', label: 'Trimestral' },
  { value: 'anual', label: 'Anual' }
];

// Limites para status de progresso
export const LIMITE_BAIXO = 0.5;  // 50% da meta
export const LIMITE_MEDIO = 0.75; // 75% da meta
export const LIMITE_ALTO = 1.0;   // 100% da meta
